import { render, staticRenderFns } from "./ConfigStyleInjector.vue?vue&type=template&id=060be47c&scoped=true"
import script from "./ConfigStyleInjector.vue?vue&type=script&lang=js"
export * from "./ConfigStyleInjector.vue?vue&type=script&lang=js"
import style0 from "./ConfigStyleInjector.vue?vue&type=style&index=0&id=060be47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060be47c",
  null
  
)

export default component.exports